export default function logError(context, error) {
  console.error(`[${context}]`, error);
}
